import React, { Fragment, Component } from "react";
import { SiteData, RouteData, Head } from "react-static";
import styled from "styled-components";
import { Centered } from "../../containers/Layout";
import { StickedNavbar, links } from "../../segments/NavbarSegment";
import Footer from "../../segments/FooterSegment";
import { ResponsiveImage } from "../../containers/ProgressiveHelpers";

const Site = styled.div`
  @media (max-width: 1810px) {
    font-size: 10px;
  }

  position: relative;
  height: 100%;
  min-height: 100vh;

  &:before {
    content: "";
    background-image: url(${props => props.src});
    background-size: cover;
    filter: saturate(0) contrast(2) blur(2.5px) opacity(0.65);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
  }

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(0, 0, 0, 0) 45%, hsl(0, 0%, 100%));
    position: absolute;
    z-index: -1;
    top: 0;
  }
`;

const Paragraph = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 1.5em;
  color: #333333;
  font-weight: 300;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 25em);
  grid-gap: 2.5em;
  justify-content: space-around;
  font-size: 0.85em;


  @media (max-width: 1000px) {
    grid-gap: 7.5em;
    justify-content: center;
  }
}
`;

const Headline = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 2.5em;
  color: #333333;
  font-weight: normal;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  text-align: center;
`;

const Card = styled.div`
  display: grid;
  grid-template-rows: 15em max-content;
  grid-template-columns: 1fr;
  font-family: "Raleway", sans-serif;
  background-color: #f4f4f4;
  color: #828282;
  border-radius: 1.5em;
  overflow: hidden;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.25);
  min-height: 100%;
  height: max-content;

  &:after {
    content: "";
    background: linear-gradient(30deg, rgb(87, 124, 255), rgb(111, 54, 255));
    width: 100%;
    height: 1em;
    box-shadow: 0px 5px 20px 0px rgba(255, 255, 255, 0.44);
    align-self: end;
  }

  &:first-child {
    min-height: min-content;
  }

  &:last-child {
    min-height: min-content;
  }

  &:nth-child(odd) {
    //background-color: #e4d9ff;
  }

  &:nth-child(even) {
    //background-color: #d9e6ff;
  }

  @media (max-width: 1000px) {
    height: 100% !important;
  }
`;

const CardImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  font-size: 1.75em;
  color: #333333;
  text-align: center;
  font-weight: bold;
  padding-left: 1em;
  padding-right: 1em;
  line-height: 3;
  box-sizing: border-box;
`;

const List = styled.ul`
  font-size: 1.25em;
  margin: 0em 1.5em 1.5em 1.5em;
  & > li {
    padding: 0.25em;
  }

  @media (max-width: 1000px) {
    justify-content: flex-start;
  }
`;

const Content = styled.div`
  padding: 5em 2.5em 5em 2.5em;

  @media (max-width: 500px) {
    margin-bottom: 5em;
  }
`;

export default () => (
  <SiteData
    render={({ title }) => (
      <RouteData
        render={({ cms }) => (
          <ResponsiveImage path={cms["background-image"]}>
            <Site>
              <Head>
                <title>Mehr erfahren - {title}</title>
              </Head>
              <StickedNavbar links={links} />
              <Content>
                <Centered style={{ padingBottom: "2.5em" }}>
                  <Headline children={cms.title} />
                </Centered>
                <Grid>
                  {cms["service-cards"].map(card => (
                    <Card key={card.title}>
                      <ResponsiveImage path={card["header-image"]}>
                        <CardImage />
                      </ResponsiveImage>
                      <Title children={card.title} />
                      <List>
                        {card.content.map(item => (
                          <li key={item} children={item} />
                        ))}
                      </List>
                    </Card>
                  ))}
                </Grid>
              </Content>
              <Footer />
            </Site>
          </ResponsiveImage>
        )}
      />
    )}
  />
);



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Services/ServicesPage.js